'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _dec4, _dec5, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _prefetch = require('chemist/dist/helpers/prefetch');

var _prefetch2 = _interopRequireDefault(_prefetch);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactDom = require('react-dom');

var _reactI18next = require('react-i18next');

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

var _lodash = require('lodash');

var _FormInput = require('../../components/FormInput');

var _localisedPaths = require('../../helpers/localisedPaths');

var _redirectable = require('../../helpers/redirectable');

var _redirectable2 = _interopRequireDefault(_redirectable);

var _flash = require('../../actions/flash');

var _order = require('../../actions/order');

var _country = require('../../actions/country');

var _loading = require('../../actions/loading');

var _address = require('../../actions/address');

var _presentation = require('../../actions/presentation');

var _order2 = require('../../helpers/order');

var _adyen = require('../../../client/actions/adyen');

var _checkout = require('../../actions/checkout');

var _CheckoutForm = require('../../components/CheckoutForm');

var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);

var _ProgressBar = require('../../components/ProgressBar');

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _RegistrationForm = require('../../components/RegistrationForm');

var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);

var _CheckoutBanner = require('../../components/CheckoutBanner');

var _CheckoutBanner2 = _interopRequireDefault(_CheckoutBanner);

var _PickupLocator = require('../../components/PickupLocator');

var _PickupLocator2 = _interopRequireDefault(_PickupLocator);

var _CheckoutHelp = require('../../components/CheckoutHelp');

var _CheckoutHelp2 = _interopRequireDefault(_CheckoutHelp);

var _CheckoutNotice = require('../../components/CheckoutNotice');

var _CheckoutNotice2 = _interopRequireDefault(_CheckoutNotice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutPage = (_dec = (0, _prefetch2.default)(function (_ref) {
  var store = _ref.store,
      params = _ref.params;

  if (_reactCookie2.default.load('hasOrder')) {
    return store.dispatch((0, _order.orderFetch)(params.step)).then(function () {
      if (params.step === 'address') {
        return store.dispatch((0, _country.countryGet)());
      }

      if (params.step === 'payment') {
        return store.dispatch((0, _order.orderPaymentMethodsFetch)());
      }

      return _promise2.default.resolve();
    });
  }

  return null;
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    postcode: state.postcode,
    order: state.order,
    presentation: state.presentation,
    country: state.country,
    flash: state.flash,
    user: state.user
  };
}), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactI18next.translate)(), _dec5 = (0, _redirectable2.default)(), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function (_React$Component) {
  (0, _inherits3.default)(CheckoutPage, _React$Component);

  function CheckoutPage() {
    var _ref2;

    (0, _classCallCheck3.default)(this, CheckoutPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CheckoutPage.__proto__ || (0, _getPrototypeOf2.default)(CheckoutPage)).call.apply(_ref2, [this].concat(args)));

    _this.state = { redirecting: false };
    return _this;
  }

  (0, _createClass3.default)(CheckoutPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.shouldRedirectToConfirmation()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/orders/' + this.props.order.number);
      } else if (this.shouldRedirectToCart()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/cart');
      } else if (this.shouldRedirectToAddress()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/checkout/address');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.dispatch((0, _loading.clearLoading)());

      if (this.shouldRedirectToConfirmation()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/orders/' + this.props.order.number);
      } else if (this.shouldRedirectToCart()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/cart');
      } else if (this.shouldRedirectToAddress()) {
        this.state.redirecting = true;
        this.props.localisedRedirect('/checkout/address');
      }
    }
  }, {
    key: 'handleGetAddresses',
    value: function handleGetAddresses(payload) {
      var _this2 = this;

      this.props.dispatch((0, _loading.setLoading)());

      this.props.dispatch((0, _address.getAddresses)(payload)).then(function () {
        return _this2.props.dispatch((0, _loading.clearLoading)());
      });
    }
  }, {
    key: 'handleGetAddress',
    value: function handleGetAddress(payload) {
      var _this3 = this;

      this.props.dispatch((0, _loading.setLoading)());

      this.props.dispatch((0, _address.getAddress)(payload)).then(function () {
        return _this3.props.dispatch((0, _loading.clearLoading)());
      });
    }
  }, {
    key: 'applyCoupon',
    value: function applyCoupon(event) {
      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());

      var data = (0, _formSerialize2.default)((0, _reactDom.findDOMNode)(this.form), { hash: true });

      return this.props.dispatch((0, _checkout.checkoutCoupon)(data));
    }
  }, {
    key: 'removeCoupon',
    value: function removeCoupon(event) {
      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());

      return this.props.dispatch((0, _checkout.couponRemove)());
    }
  }, {
    key: 'shouldRedirectToConfirmation',
    value: function shouldRedirectToConfirmation() {
      if (this.state.redirecting) {
        return false;
      }

      if (!this.props.order) {
        return false;
      }

      if (this.props.order.state === 'complete') {
        return true;
      }

      return false;
    }
  }, {
    key: 'shouldRedirectToAddress',
    value: function shouldRedirectToAddress() {
      if (this.state.redirecting) {
        return false;
      }

      if (this.props.params.step !== 'registration') {
        return false;
      }

      if (_reactCookie2.default.load('sessionToken')) {
        return true;
      }

      return false;
    }
  }, {
    key: 'shouldRedirectToCart',
    value: function shouldRedirectToCart() {
      if (this.state.redirecting) {
        return false;
      }

      if (!this.props.order) {
        return true;
      }

      if (this.props.order.paymentUrl) {
        return false;
      }

      if (!_reactCookie2.default.load('hasOrder')) {
        return true;
      }

      if (!this.props.order.number) {
        return true;
      }

      if (this.props.order.state === 'complete') {
        return true;
      }

      if (!(0, _order2.orderHasLineItems)(this.props.order)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isRedirectingToPaymentUrl',
    value: function isRedirectingToPaymentUrl() {
      return this.props.order.paymentUrl || this.props.order.number === undefined;
    }
  }, {
    key: 'guestCheckout',
    value: function guestCheckout(event) {
      var _this4 = this;

      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());
      this.props.dispatch((0, _order.orderNext)('cart')).then(function () {
        return _this4.props.localisedRedirect('/checkout/address');
      });
    }
  }, {
    key: 'cardData',
    value: function cardData() {
      return {
        number: document.getElementById('cc-number').value,
        cvc: document.getElementById('cc-cvc').value,
        holderName: document.getElementById('cc-holdername').value,
        expiryMonth: document.getElementById('cc-expiry-month').value,
        expiryYear: document.getElementById('cc-expiry-year').value
      };
    }
  }, {
    key: 'appendPaymentType',
    value: function appendPaymentType(data) {
      var _this5 = this;

      if (!(0, _lodash.hasIn)(data, 'order.payments_attributes')) {
        return _promise2.default.resolve(data);
      }

      var paymentMethodId = data.order.payments_attributes[0].payment_method_id;
      var paymentMethod = (0, _order2.paymentMethodById)(this.props.order.paymentMethods, paymentMethodId);

      data.order.payments_attributes[0].payment_method_type = paymentMethod.methodType;

      if (paymentMethod.methodType === 'adyen') {
        return _promise2.default.resolve(data);
      }

      var cardFormData = this.cardData();

      return new _promise2.default(function (accept, reject) {
        return (0, _adyen.adyenCsePayment)(cardFormData, _this5.props.config.store.adyenPublicKey, _this5.props.t).then(function (encryptedData) {
          data.order.payments_attributes[0].source_attributes = { encrypted_data: encryptedData };
          accept(data);
        }).catch(function (err) {
          return reject(err);
        });
      });
    }
  }, {
    key: 'redirectToNextStep',
    value: function redirectToNextStep() {
      if (this.props.order.paymentUrl) {
        this.props.dispatch((0, _loading.setLoading)());
        return null;
      }

      if (this.props.order.error) {
        return null;
      }

      if (this.props.order.state === 'complete') {
        return this.props.localisedRedirect('/orders/' + this.props.order.number);
      }

      return this.props.localisedRedirect('/checkout/' + this.props.order.state);
    }
  }, {
    key: 'displayErrorFlash',
    value: function displayErrorFlash(error) {
      this.props.dispatch((0, _flash.setFlash)({ payment_error_message: error }));
      this.props.dispatch((0, _loading.clearLoading)());
    }
  }, {
    key: 'updateForm',
    value: function updateForm(event) {
      var _this6 = this;

      event.preventDefault();
      this.props.dispatch((0, _loading.setLoading)());

      var orderNumber = this.props.order.number;
      var state = this.props.params.step;
      var node = (0, _reactDom.findDOMNode)(this.form);
      var data = this.findFormDataFor(node);

      this.appendPaymentType(data).then(function (checkoutData) {
        return _this6.props.dispatch((0, _checkout.checkoutNext)(state, orderNumber, checkoutData));
      }).then(this.redirectToNextStep.bind(this)).catch(this.displayErrorFlash.bind(this));
    }
  }, {
    key: 'findFormDataFor',
    value: function findFormDataFor(node) {
      if (node.nodeName === 'FORM') {
        return (0, _formSerialize2.default)(node, { hash: true });
      }

      return (0, _formSerialize2.default)(node.children[1], { hash: true });
    }
  }, {
    key: 'toggleOrderSummary',
    value: function toggleOrderSummary(event) {
      event.preventDefault();

      if (this.props.presentation.orderSummaryVisible) {
        this.props.dispatch((0, _presentation.hideOrderSummary)());
      } else {
        this.props.dispatch((0, _presentation.showOrderSummary)());
      }
    }
  }, {
    key: 'hideCheckoutHelp',
    value: function hideCheckoutHelp() {
      this.props.dispatch((0, _presentation.hideCheckoutHelp)());
    }
  }, {
    key: 'hideCheckoutNotice',
    value: function hideCheckoutNotice() {
      this.props.dispatch((0, _presentation.hideCheckoutNotice)());
    }
  }, {
    key: 'formRender',
    value: function formRender() {
      var _context,
          _this7 = this;

      if (this.props.params.step === 'registration') {
        return _react2.default.createElement(_RegistrationForm2.default, {
          order: this.props.order,
          onGuestCheckout: this.guestCheckout.bind(this),
          params: this.props.params
        });
      }

      return _react2.default.createElement(_CheckoutForm2.default, {
        step: this.props.params.step,
        order: this.props.order,
        billAddressDetail: this.props.postcode.billAddressDetail,
        billAddresses: this.props.postcode.billAddresses,
        shipAddressDetail: this.props.postcode.shipAddressDetail,
        shipAddresses: this.props.postcode.shipAddresses,
        country: this.props.country,
        presentation: this.props.presentation,
        errors: this.props.order.error,
        user: this.props.user,
        onSubmit: this.updateForm.bind(this),
        onOrderSummaryToggle: this.toggleOrderSummary.bind(this),
        onCouponApply: this.applyCoupon.bind(this),
        onCouponRemove: this.removeCoupon.bind(this),
        onGetAddresses: this.handleGetAddresses.bind(this),
        onGetAddress: this.handleGetAddress.bind(this),
        dispatch: (_context = this.props).dispatch.bind(_context),
        flash: this.props.flash,
        params: this.props.params,
        ref: function ref(el) {
          return _this7.form = el;
        },
        tempPickupLocatorSet: this.props.location.query.collection,
        tempPromotionsEnabledSet: this.props.location.query.promotions
      });
    }
  }, {
    key: 'renderRedirect',
    value: function renderRedirect() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_CheckoutBanner2.default, { title: 'Redirecting' }),
        _react2.default.createElement(
          'div',
          { className: 'container container-page' },
          _react2.default.createElement(
            'p',
            { className: 't-text--centered t-text' },
            'Please wait...'
          )
        )
      );
    }
  }, {
    key: 'renderProcessing',
    value: function renderProcessing() {
      var lng = this.props.params.lng;
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_CheckoutBanner2.default, { title: t('spree.payment_processing_title') }),
        _react2.default.createElement(
          'div',
          { className: 'container container-page' },
          _react2.default.createElement(
            'p',
            { className: 't-text--centered t-text' },
            t('spree.payment_processing'),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _FormInput.ButtonLink,
              {
                url: (0, _localisedPaths.localisedRoot)(this.props.config.store, lng),
                weight: 'secondary'
              },
              t('spree.return_to_store')
            )
          )
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: t('spree.payment_processing_title') })
      );
    }
  }, {
    key: 'renderCheckout',
    value: function renderCheckout() {
      var _props = this.props,
          t = _props.t,
          config = _props.config;
      var theme = config.theme;

      var title = theme === 'woodcare' ? t('woodcare.checkout.' + this.props.params.step) : t('spree.checkout');

      if (this.isRedirectingToPaymentUrl() || this.props.order.state === 'complete') {
        return this.renderRedirect();
      }

      if (this.props.params.step === 'processing') {
        return this.renderProcessing();
      }

      var className = 'container container-page container-page-' + this.props.params.step + '-step';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _CheckoutBanner2.default,
          { title: title },
          _react2.default.createElement(_ProgressBar2.default, {
            currentStep: this.props.params.step,
            availableSteps: ['address', 'delivery', 'payment']
          })
        ),
        _react2.default.createElement(
          'div',
          { className: className },
          _react2.default.createElement(_reactHelmet2.default, { title: t('spree.checkout') }),
          this.formRender()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.presentation.pickupLocatorVisible) {
        return _react2.default.createElement(_PickupLocator2.default, null);
      }

      if (this.props.presentation.checkoutHelpVisible) {
        return _react2.default.createElement(_CheckoutHelp2.default, { close: this.hideCheckoutHelp.bind(this) });
      }

      if (this.props.presentation.checkoutInfoVisible) {
        return _react2.default.createElement(_CheckoutNotice2.default, { close: this.hideCheckoutNotice.bind(this) });
      }

      return this.renderCheckout();
    }
  }]);
  return CheckoutPage;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = CheckoutPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/CheckoutPage/index.js
// module id = 2328
// module chunks = 0